import { Controller } from 'react-hook-form';

import { Select } from 'components/DesignSystem/Select';
import classes from 'components/Settings/Components/UserProfile/components/userProfile.module.scss';
import { USER_STATUS_OPTIONS } from 'components/Settings/Components/UserProfile/userProfile.constants';

export const UserStatus = ({ control }) => {
    return (
        <div className={classes.userStatusContainer}>
            <div>Status: </div>
            <Controller
                render={({ field }) => <Select<ISelectOption<string>> {...field} options={USER_STATUS_OPTIONS} />}
                name={'status'}
                control={control}
            />
        </div>
    );
};
